/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartPaymentResultDto
 */
export interface StartPaymentResultDto {
    /**
     * 
     * @type {string}
     * @memberof StartPaymentResultDto
     */
    paymentUniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof StartPaymentResultDto
     */
    redirectUrl?: string | null;
}

export function StartPaymentResultDtoFromJSON(json: any): StartPaymentResultDto {
    return StartPaymentResultDtoFromJSONTyped(json, false);
}

export function StartPaymentResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartPaymentResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentUniqueId': !exists(json, 'paymentUniqueId') ? undefined : json['paymentUniqueId'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
    };
}

export function StartPaymentResultDtoToJSON(value?: StartPaymentResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentUniqueId': value.paymentUniqueId,
        'redirectUrl': value.redirectUrl,
    };
}

